module.exports = __webpack_public_path__ + "img/accounts-default-usa.de918a02.svg";